import { Controller } from '@hotwired/stimulus'
import { destroy } from '../lib/request'

export default class extends Controller {
  static values = { id: Number }
  static targets = ['item']

  delete = async (event) => {
    event.preventDefault()

    const confirmed = confirm('Remove this like?')
    if (!confirmed) return

    const response = await destroy(`/likes/${this.idValue}`, {
      responseKind: 'json',
    })

    if (response.ok) {
      // Remove element from DOM
      this.itemTarget.remove()
    }
    else {
      alert('Failed to delete like')
    }
  }
}
